import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

import { computed, provide, ref, toRefs } from 'vue';
import { checkitem } from "@/utilities";
import { Room, Section, Type, Item, Note } from "@/models";
import ReportRoomItem from "@/components/depository/Item.vue";

// Define props with type annotations

export default /*#__PURE__*/_defineComponent({
  __name: 'Type',
  props: {
    index: {},
    room: {},
    section: {},
    type: {}
  },
  setup(__props: any) {

const props = __props;

// Destructuring props as refs
const { room, section, type } = toRefs(props);

// Provide values
const typeIndex = ref(props.index);
const typeSlug = computed(() => type.value?.slug);
const typeName = computed(() => type.value?.name);

// Provide functions
provide("typeIndex", typeIndex);
provide("typeSlug", typeSlug);
provide("typeName", typeName);

// Computed property for filtered items
const itemswithdeductions = computed(() => {
  return type.value?.items.filter((item: Item) =>
    checkitem(room.value, section.value, type.value, item)
  ) || [];
});

// Method to get item index
const getItemIndex = (item: Item): number => {
  return type.value?.items.findIndex((i: Item) => i._uuid === item._uuid) ?? -1;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemswithdeductions.value, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item._uuid
      }, [
        _createVNode(ReportRoomItem, {
          item: item,
          index: getItemIndex(item)
        }, null, 8, ["item", "index"])
      ]))
    }), 128))
  ]))
}
}

})